<div class="d-flex align-items-center">
	<img width="{{ size }}" height="{{ size }}" class="bg-light rounded-circle me-2" [ngSrc]="profileImageSrc" alt="worker logo" *ngIf="profileImageSrc" />
	<span>{{ fullName }}</span>
</div>
